import React, { useState } from 'react';
import Slider from 'react-slick';
import { useSpring, animated } from '@react-spring/web';
import { useInView } from 'react-intersection-observer';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './CaseStudiesCarousel.css';

// Import GIFs instead of static images
import pdfGif1 from '../../../assets/pdfImages/Capitec_Case_Study_Gif.gif';
import pdfGif2 from '../../../assets/pdfImages/Marmite_Case_Study_Gif.gif';
import pdfGif3 from '../../../assets/pdfImages/Simba_Case_Study_Gif.gif';
import pdfGif4 from '../../../assets/pdfImages/Nik_Nak_Case_Study_Gif.gif';

// Configuration data
const CASE_STUDIES = [
  { id: 1, image: pdfGif1, alt: 'Capitec Case Study' },
  { id: 2, image: pdfGif2, alt: 'Marmite Case Study' },
  { id: 3, image: pdfGif3, alt: 'Munchiez Case Study' },
  { id: 4, image: pdfGif4, alt: 'Nik Naks Case Study' },
];

const SLIDER_CONFIG = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  centerMode: true,
  centerPadding: '150px', // Reduced to show more of the main slide
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: true,
  pauseOnFocus: true,
  pauseOnDotsHover: true,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        centerPadding: '200px',
        autoplay: true,
        autoplaySpeed: 5000,
      },
    },
    {
      breakpoint: 1400,
      settings: {
        centerPadding: '150px',
        autoplay: true,
        autoplaySpeed: 5000,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        centerPadding: '100px',
        autoplay: true,
        autoplaySpeed: 5000,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        centerPadding: '50px',
        autoplay: true,
        autoplaySpeed: 5000,
      },
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: false,
        centerPadding: '0px',
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
      },
    },
  ],
};
const CaseStudiesCarousel = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  // Intersection Observer for scroll animation
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Animation configuration
  const animationProps = useSpring({
    transform: inView ? 'scale(1)' : 'scale(0.8)',
    opacity: inView ? 1 : 0,
    config: { tension: 170, friction: 12 },
  });

  // Merge settings with afterChange handler
  const sliderSettings = {
    ...SLIDER_CONFIG,
    afterChange: current => setActiveSlide(current),
  };

  return (
    <animated.div
      ref={ref}
      style={animationProps}
      className="carousel-container-main"
    >
      <h2 className="carousel-heading-main">Case Studies</h2>
      <Slider {...sliderSettings}>
        {CASE_STUDIES.map((study, index) => (
          <div
            key={study.id}
            className={`carousel-item-main ${
              activeSlide === index ? 'active-slide' : ''
            }`}
          >
            <img
              src={study.image}
              alt={study.alt}
              className="carousel-image-main"
              loading="lazy"
            />
          </div>
        ))}
      </Slider>
    </animated.div>
  );
};

export default CaseStudiesCarousel;
